<span class="data-table-multi-select-filter__label">{{ label }}</span>
<mat-form-field appearance="fill" subscriptSizing="dynamic">
  <mat-select
    [attr.aria-label]="label"
    [value]="selectedValues"
    [disabled]="disabled"
    [panelClass]="resolvedPanelClass"
    multiple
    (closed)="markAsTouched()">
    <mat-select-trigger>{{ selectionLabel }}</mat-select-trigger>

    <ng-container *ngIf="groups.length === 0; else groupedOptions">
      <mat-option *ngFor="let option of options; trackBy: trackByOptionValue" [value]="option.value" (onSelectionChange)="onOptionSelectionChange($event)">{{ option.label ?? option.value }}</mat-option>
    </ng-container>

    <ng-template #groupedOptions>
      <ng-container *ngFor="let group of groups; trackBy: trackByGroupLabel">
        <div class="data-table-multi-select-filter__group" (click)="$event.stopPropagation()">
          <mat-checkbox
            [checked]="isGroupSelected(group)"
            [indeterminate]="isGroupIndeterminate(group)"
            (change)="toggleGroup(group, $event.checked)">
            {{ group.label }}
          </mat-checkbox>
          <button
            *ngIf="isGroupExpandable(group)"
            type="button"
            class="data-table-multi-select-filter__group-toggle"
            [attr.aria-label]="isGroupExpanded(group) ? 'Ocultar niveles de ' + group.label : 'Mostrar niveles de ' + group.label"
            (click)="toggleGroupExpanded(group)">
            <mat-icon>{{ isGroupExpanded(group) ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>

        <ng-container *ngIf="isGroupExpandable(group)">
          <mat-option class="data-table-multi-select-filter__group-child" [class.data-table-multi-select-filter__group-child--collapsed]="!isGroupExpanded(group)" *ngFor="let value of group.values" [value]="value" (onSelectionChange)="onOptionSelectionChange($event)">
            {{ getOption(value)?.label ?? value }}
          </mat-option>
        </ng-container>
      </ng-container>
    </ng-template>

    <mat-divider></mat-divider>
    <div class="data-table-multi-select-filter__select-all" (click)="$event.stopPropagation()">
      <mat-checkbox
        [checked]="areAllSelected"
        [indeterminate]="hasSelectedOptions && !areAllSelected"
        (change)="toggleAll($event.checked)">
        Seleccionar todos
      </mat-checkbox>
    </div>
  </mat-select>
</mat-form-field>
